// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import 'medium-editor/dist/css/medium-editor.css'
import 'medium-editor/dist/css/themes/flat.css'
import './fonts/css/styles.css'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import App from './App'
import router from './router'
import '@/plugins/moment'
import '@/filters/date'
import Navigation from './components/Navigation'
import Editor from './components/Editor'
import ReferenceAndNoteList from './components/ReferenceAndNoteList'
import ModifiedDate from './components/ModifiedDate'
import store from './store'
import { getAll } from './store/actions'
import auth from './services/auth'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import Multiselect from 'vue-multiselect'
import BackToTop from 'vue-backtotop'
import VeeValidate from 'vee-validate'
import VueCompositionAPI from '@vue/composition-api'
import vClickOutside from 'v-click-outside'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(MuseUI)
Vue.use(VueLodash, lodash)
Vue.use(BackToTop)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
})
Vue.use(vClickOutside)
Vue.use(VueCompositionAPI)
Vue.component('navigation', Navigation)
Vue.component('editor', Editor)
Vue.component('reference-and-note-list', ReferenceAndNoteList)
Vue.component('multiselect', Multiselect)
Vue.component('modified-date', ModifiedDate)
// set baseUrl from app
axios.defaults.baseURL = process.env.BASE_URL
axios.defaults.headers.get['If-Modified-Since'] = '0'

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response) {
    // if (error.response.status === 500) {
    //   var msg = `${error.response.data}`
    //   displayErrorMessage(store, msg)
    //   return Promise.reject(error)
    // }
    if (error.response.status === 401) {
      auth.checkAuth()
      router.push('/logga-in')
    }
    return error.response
  } else {
    return Promise.reject(error)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

auth.checkAuth()

sessionStorage.removeItem('last_api_get')
getAll(store)

VeeValidate.Validator.extend('no_surrounding_space', {
  validate: value => /^$|^\S$|^\S.*\S$/.test(value),
  getMessage: () => 'Inga omgivande mellanslag tillåtna'
})

VeeValidate.Validator.localize('en', {
  messages: {
    required: () => 'Fältet är obligatoriskt'
  }
})
